<template>
  <div>
    <van-popup v-model="showPop" position="right" style="height: 100%; width: 80%" @click-overlay="closePopup">
      <div class="btn-wrap">
        <div class="pop-title">
          <p>搜索筛选区</p>
          <van-icon name="cross" @click="cancel"/>
        </div>
        <div class="select_list">
          <!-- <van-collapse v-model="activeNames" accordion>
            <van-collapse-item title="客户等级" name="1">
              <van-button style="margin-right:5px;margin-bottom:5px;" :color="custLevelIndex === index ? 'blue' : ''" plain hairline size="small" v-for="(item,index) in custLevelOptions" :key="item.custLevelId" @click="handleClick('custLevel',item.custLevelId,index)">{{ item.levelName }}</van-button>
            </van-collapse-item>
            <van-collapse-item title="客户来源" name="2">
              <van-button style="margin-right:5px;margin-bottom:5px;" :color="custSourceIndex === index ? 'blue' : ''" plain hairline size="small" v-for="(item,index) in custSourceOptions" :key="item.dictValue" @click="handleClick('custSource',item.dictValue,index)">{{ item.dictLabel }}</van-button>
            </van-collapse-item>
            <van-collapse-item title="客户类型" name="3">
              <van-button style="margin-right:5px;margin-bottom:5px;" :color="custTypeIndex === index ? 'blue' : ''" plain hairline size="small" v-for="(item,index) in custTypeOptions" :key="item.dictValue" @click="handleClick('custType',item.dictValue,index)">{{ item.dictLabel }}</van-button>
            </van-collapse-item>
          </van-collapse> -->
        </div>

      </div>
      <div class="input-wrap">
        <van-cell-group>
          <van-field v-model="queryParams.custName" label="客户名称" placeholder="请填写客户名称" />
          <van-field readonly clickable v-model="queryParams.unitNatureName" @click="showPicker('unitNature')" label="单位性质" placeholder="请选择单位性质" />
          <van-field readonly clickable v-model="queryParams.industryName" label="所属行业" @click="showPicker('industry')" placeholder="请选择所属行业" />
          <van-field readonly clickable v-model="queryParams.custLevelName" @click="showPicker('custLevel')" label="客户等级" placeholder="请选择客户等级" />
          <van-field v-model="time" readonly clickable name="calendar" label="时间" placeholder="点击选择时间" @click="showCalendar()" />
            <!-- <template #button>
              <van-icon name="close" @click.stop="clear('custLevel')" />
            </template>
          </van-field> -->
          <!-- <van-field v-if="userId == '2' || userId == '19' || userId == '20'" readonly clickable v-model="deptName" @click="showPicker('dept')" label="部门" placeholder="选择部门" /> -->
          <!-- <van-collapse v-model="activeNames">
            <van-collapse-item title="客户类型" name="1">
              <div style="display: flex;flex-wrap: wrap;">
                <div style="margin: 0.1rem;" v-for="(v, i) in custTypeOptions" :key="i">
                  <van-tag @click="custType('type',i)" size="medium" plain type='primary' :text-color="!v.isCheck ? '#c1c1c1' : ''">{{ v.dictLabel }}</van-tag>
                </div>
              </div>
            </van-collapse-item>
            <van-collapse-item title="客户状态" name="2">
              <div style="display: flex;flex-wrap: wrap;">
                <div style="margin: 0.1rem;" v-for="(v, i) in custStateOptions" :key="i">
                  <van-tag @click="custType('state',i)" size="medium" plain type='primary' :text-color="!v.isCheck ? '#c1c1c1' : ''">{{ v.dictLabel }}</van-tag>
                </div>
              </div>
            </van-collapse-item>
            <van-collapse-item title="企业规模" name="3">
              <div style="display: flex;flex-wrap: wrap;">
                <div style="margin: 0.1rem;" v-for="(v, i) in custScaleOptions" :key="i">
                  <van-tag @click="custType('scale',i)" size="medium" plain type='primary' :text-color="!v.isCheck ? '#c1c1c1' : ''">{{ v.dictLabel }}</van-tag>
                </div>
              </div>
            </van-collapse-item>
            <van-collapse-item title="单位性质" name="4">
              <div style="display: flex;flex-wrap: wrap;">
                <div style="margin: 0.1rem;" v-for="(v, i) in custNatureOptions" :key="i">
                  <van-tag @click="custType('nature',i)" size="medium" plain type='primary' :text-color="!v.isCheck ? '#c1c1c1' : ''">{{ v.dictLabel }}</van-tag>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse> -->
          <van-field v-model="queryParams.userName" label="跟进人" placeholder="请输入跟进人" />
        </van-cell-group>
      </div>
      <div class="footer-btn-wrap">
        <van-button size="mini" plain  type="info" class="resetBtn" @click="resetQuery">重置</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="submitForm">搜索</van-button>
        <van-button size="mini" type="default" class="submitbtn" @click="cancel">取消</van-button>
      </div>
    </van-popup>

    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
    </van-popup>
    <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :type="datePicker.type" @confirm="dateConfirm" />
  </div>
</template>
<script>
// import { selectAllCustLevel } from "@/api/scrm/custlevel";
import { getDicts } from '@/api/system/dict/data'
import { Field, Popup, Icon, Button, Cell, CellGroup, CollapseItem, Divider, Collapse } from 'vant'
export default {
  name: 'SearchPop',
  props: ['show'],
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Divider.name]: Divider
  },
  data() {
    return {
      activeNames: [],
      showPop: false,
      custLevelIndex: null,
      custSourceIndex: null,
      custTypeIndex: null,
      queryParams: {
        unitNature: '',
        params: {
          beginTime: '',
          endTime: ''
        }
      },
      // 客户等级
      custLevelOptions: [],
      // 客户来源字典
      custSourceOptions: this.$store.state.dictOptions.custSource || [],
      // 客户类型
      custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
      selectType: null,
      // 客户状态
      custStateOptions: [],
      selectState: null,
      // 单位性质 crm_unit_nature
      custNatureOptions: [],
      selectNature: null,
      // 企业规模 crm_scale
      custScaleOptions: [],
      selectScale: null,
      picker: {
        visible: false,
        visibleIndustry: false,
        title: '',
        columns: [],
        formKey: ''
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2010, 0, 1),
        type: 'single',
        formKey: ''
      },
      time: '',
      options: {
        custLevelOptions: [],
        unitNatureOptions: [],
        // 客户类型字典
        // custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
        // 行业类型
        businessTypeOptions: this.$store.state.dictOptions.businessTypeTree || [],
        // 客户来源字典
        custSourceOptions: this.$store.state.dictOptions.custSource || [],
        // 客户状态
        custStatusOptions: this.$store.state.dictOptions.custStatus || [],
        // 性别状态字典
        // sexOptions: this.$store.state.dictOptions.sex || [],
        // 行业
        industryOptions: this.$store.state.dictOptions.industry || []
      }
    }
  },
  watch: {
    show: function (newVal, oldVal) { // 不能用箭头函数
      this.showPop = newVal
    }
  },
  mounted() {
    // this.getCustLevelList()
    // 客户类型
    getDicts('crm_mycust_type').then(res => {
      this.custTypeOptions = res.data
      this.custTypeOptions.forEach(e => {
        e.isCheck = false
      })
    })
    // 客户状态
    getDicts('crm_cust_status').then(res => {
      this.custStateOptions = res.data
      this.custStateOptions.forEach(e => {
        e.isCheck = false
      })
    })
    // 单位性质
    // getDicts('crm_unit_nature').then(res => {
    //   this.custNatureOptions = res.data
    //   this.custNatureOptions.forEach(e => {
    //     e.isCheck = false
    //   })
    // })
    getDicts('crm_unit_nature').then(res => {
      this.options.unitNatureOptions = res.data
    })
    // 企业规模
    getDicts('crm_scale').then(res => {
      this.custScaleOptions = res.data
      this.custScaleOptions.forEach(e => {
        e.isCheck = false
      })
    })
    getDicts('crm_cust_level').then(res => {
      this.options.custLevelOptions = res.data
    })
  },
  methods: {
    handleClick(type, prop, index) {
      switch (type) {
        case 'custLevel':
          this.queryParams.custLevelId = prop
          this.custLevelIndex = index
          break
        case 'custSource':
          this.queryParams.custSource = prop
          this.custSourceIndex = index
          break
        case 'custType':
          this.queryParams.custType = prop
          this.custTypeIndex = index
          break
        default:
          console.log('handleClick', type, prop)
      }
    },
    /** 转换行业数据结构 */
    industryNormalizer(node) {
      const arr = []
      if (node.children && node.children.length) {
        for (const i in node.children) {
          const item = {
            id: node.children[i].systemIndustryId,
            text: node.children[i].industryName
          }
          arr.push(item)
        }
      }

      return {
        id: node.systemIndustryId,
        text: node.industryName,
        children: arr
      }
    },
    showPicker(type) {
      if (type === 'industry') {
        console.log(this.options.industryOptions)
        this.options.industryOptions.map(item => {
          item.dictLabel = item.industryName
          item.dictValue = item.systemIndustryId
        })
        this.picker.formKey = type
        const optionItem = type + 'Options'
        // this.picker.columns = this.options[optionItem].map((ele) => this.industryNormalizer(ele))
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        //   this.picker.columns = this.businessTypeOptions.map(ele => this.businessNormalizer(ele))
        // this.picker.columns = this.options[optionItem].map(ele => this.industryNormalizer(ele))
        this.picker.visible = true
      } else {
        this.picker.formKey = type
        const optionItem = type + 'Options'
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.visible = true
      }
    },
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      console.log('key:' + key)
      const name = this.picker.formKey + 'Name'
      if (this.picker.formKey == 'industry') {
        // if (value.length == 2) {
        //   if (value[1].length > 0) {
        //     const obj = this.options[optionItem].find(
        //       (item) => item.industryName === value[0]
        //     )
        //     if (obj != null) {
        //       this.queryParams.industryCode = obj.children.find(
        //         (item) => item.industryName === value[1]
        //       ).systemIndustryId
        //     }
        //     this.queryParams.industryName = value[0] + '/' + value[1]
        //   }
        // } else {
        //   this.queryParams.industryName = value[0]
        //   const obj = this.options[optionItem].find(
        //     (item) => item.industryName === value[0]
        //   )
        //   if (obj != null) {
        //     this.queryParams.industryCode = obj.systemIndustryId
        //   }
        // }
        this.queryParams.industryName = value
        this.queryParams.industryCode = this.options.industryOptions[key].dictValue
      } else {
        this.queryParams[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.queryParams[name] = this.options[optionItem][key].dictLabel
      }
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    pickerChange() { },
    // 获取用户等级
    // getCustLevelList() {
    //   selectAllCustLevel(null).then(response => {
    //     this.custLevelOptions = response.data;
    //   });
    // },
    showCalendar(type) {
      this.datePicker.formKey = type
      this.datePicker.type = 'range'
      this.datePicker.showDate = true
    },
    dateConfirm(date) {
      this.queryParams.dayType = null
      this.activeId = null
      const [start, end] = date
      this.queryParams.params.beginTime = this.formatDate(start)
      this.queryParams.params.endTime = this.formatDate(end)
      this.time = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
      this.datePicker.showDate = false
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    resetQuery() {
      this.queryParams = {
        custLevelId: null,
        custName: null,
        custSource: null,
        custType: null,
        industryName: null,
        industryCode: null,
        unitNature: null,
        unitNatureName: null,
        custLevel: null,
        custLevelName: null,
        params: {
          beginTime: '',
          endTime: ''
        }
      }
      this.time = ''
      this.custLevelIndex = null
      this.custSourceIndex = null
      this.custTypeIndex = null
      const resetOption = (queryOption) => {
        queryOption.forEach(v => {
          v.isCheck = false
        })
      }
      resetOption(this.custTypeOptions)
      resetOption(this.custStateOptions)
      resetOption(this.custScaleOptions)
      resetOption(this.custNatureOptions)
      this.selectState = null
      this.selectNature = null
      this.selectScale = null
      this.selectType = null
      this.submitForm()
    },
    submitForm() {
      // this.queryParams.custType = this.selectType
      // this.queryParams.custState = this.selectState
      // this.queryParams.scale = this.selectScale
      // this.queryParams.unitNature = this.selectNature
      this.$emit('handlequery', this.queryParams)
    },
    cancel() {
      this.showPop = false
      this.$emit('update:show', false)
    },
    closePopup() {
      this.showPop = false
      this.$emit('update:show', false)
    },
    custType(type, i) {
      switch (type) {
        case 'type':
          this.custTypeOptions.forEach((v, index) => {
            if (i === index) {
              this.custTypeOptions[i].isCheck = !this.custTypeOptions[i].isCheck
              if (this.custTypeOptions[i].isCheck) {
                this.selectType = this.custTypeOptions[i].dictValue
              } else {
                this.selectType = ''
              }
              this.$forceUpdate()
            } else {
              v.isCheck = false
            }
          })
          break
        case 'state':
          this.custStateOptions.forEach((v, index) => {
            if (i === index) {
              this.custStateOptions[i].isCheck = !this.custStateOptions[i].isCheck
              if (this.custStateOptions[i].isCheck) {
                this.selectState = this.custStateOptions[i].dictValue
              } else {
                this.selectState = ''
              }
              this.$forceUpdate()
            } else {
              v.isCheck = false
            }
          })
          break
        case 'nature':
          this.custNatureOptions.forEach((v, index) => {
            if (i === index) {
              this.custNatureOptions[i].isCheck = !this.custNatureOptions[i].isCheck
              if (this.custNatureOptions[i].isCheck) {
                this.selectNature = this.custNatureOptions[i].dictValue
              } else {
                this.selectNature = ''
              }
              this.$forceUpdate()
            } else {
              v.isCheck = false
            }
          })
          break
        case 'scale':
          this.custScaleOptions.forEach((v, index) => {
            if (i === index) {
              this.custScaleOptions[i].isCheck = !this.custScaleOptions[i].isCheck
              if (this.custScaleOptions[i].isCheck) {
                this.selectScale = this.custScaleOptions[i].dictValue
              } else {
                this.selectScale = ''
              }
              this.$forceUpdate()
            } else {
              v.isCheck = false
            }
          })
          break
        default:
      }
    },
    clear() {
      // console.log('233')
    }
  }
}
</script>
<style lang="less">
.btn-wrap {
  width: 100%;
  box-sizing: border-box;
  .close-icon {
    width: 20px;
    height: 20px;
  }
  .pop-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 36px;
    font-weight: bold;
    padding: 0;
    padding: 0 30px;
  }
  .type-list {
    margin-bottom: 40px;
    .title {
      font-size: 28px;
      font-weight: bold;
    }
    .list-wrapper {
      line-height: 0.5;
    }
  }
  .input-wrap {
    margin-top: 20px;
  }
  .select_list {
    .van-button {
      margin-top: 10px !important;
      margin-bottom: 10px !important;
    }
  }
}
.footer-btn-wrap {
  position: fixed;
  bottom: 100px;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 30px;

  display: flex;
  justify-content: space-around;

  .van-button {
    width: 45%;
    height: 60px;
    font-size: 30px;

    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  }
}
</style>
